const SET_PENALTY_LIST = '@penalty/set-penalty-list';
const SET_PENALTY_DETAIL = '@penalty/set-penalty-detail';
const SET_PENALTY_LIST_TOTAL = '@penalty/set-penalty-list-total';

export {SET_PENALTY_LIST, SET_PENALTY_DETAIL, SET_PENALTY_LIST_TOTAL};